<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">解绑</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="block ub ub-ver">
      <li class="main ub ub-pc ub-ac2" v-for="(item, index) in student" :key="index">
        <div class="ub">
          <img :src="item.photo" class="photo" />
          <div class="ub ub-ver ub-ac">
            <div class="ub ub-pc" style="font-size: 0.95rem">
              <span>{{ item.nick }}</span>
              <div class="ub ub-pc">
                (
                <img v-if="item.sex == '女生'" src="../../assets/img/女.png" class="sex-img"/>
                <img v-if="item.sex == '男生'" src="../../assets/img/男.png" class="sex-img"/>
                <span :class="item.sex == '女生' ? 'sex' : 'sex2'">{{item.sex}}</span>
                )
              </div>
            </div>
            <div class="ub">
              <span class="sp1">总积分:<label class="total-score">{{item.s_total}}</label></span>
            </div>
          </div>
        </div>

        <div class="btn ub ub-pc ub-ac" @click="relieve(item.uid)">解绑</div>
      </li>
    </div>
    <dlg ref="myForm" @formBehavior="formact_relieve"></dlg>
    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../../components/Form.vue";
import Alert from "../../components/Alert.vue";
export default {
  components: {
    dlg: Form,
    alert: Alert,
  },
  data() {
    return {
      coin_left: 0,
      student: [],
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo","act_sub_coin"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    init_page() {
      var self = this;
      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user_info = u;
          self.coin_left = u.coin_left;
        },
      });

      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/GetApprenticeList/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.student = data;
          for (var i = 0; i < data.length; i++) {
            data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
        },
      });
    },
    relieve(uid_to) {
      var h =
        "<div>\
            <div style='border:1px solid #dcdcdc;border-radius: 0.3em; padding: 0.5em;font-size:.9em;'>一日为师，终身为父，请三思哈；如果确实要解除师徒关系，你需要支付300金币赠送给徒弟，以此来断绝师徒关系，点击下方【解除】按钮，即可马上解除师徒关系</div>\
         </div>";

      this.$refs.myForm.show(h, {
        type: "confirm",
        confirmText: "解除",
        titleText: "解除师徒关系",
        data: uid_to,
      });
    },

    formact_relieve(type, uid_to) {
      if (type != "clickConfirm") {
        return false;
      }

      //判断剩余金币是否够支付
      if (this.coin_left < 300) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      //扣除金币
      var uid = this.$store.state.uid;
      var data = {
        "uid":uid,
        "uid_to":uid_to,
        "coin":300
      };
      this.sub_coin_relieve(data);

    },


    //解除师徒关系函数
    dorelieve(uid_to) {
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/S_Unbundling/?uid=" + uid + "&uid_to=" + uid_to,
        success: function (data_rst) {
          //console.log(data_rst);
          if (data_rst == "1") {
            self.$toast.center("解除成功");
            self.init_page();
          } else {
            self.$toast.center("解除失败,请退出重试");
          }
        },
      });
    },

    //扣除金币
    sub_coin_relieve(data) {
     
      var send_data = {
        "uid_from": data.uid,
        "uid_to": data.uid_to,
        "amount": data.coin,
        "type_dtl": "解除师徒关系",
        "comment": "师父发起",
      };
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          //console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.dorelieve(data.uid_to);
          }
        },
      });
    },

    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },
  },
};
</script>
 
<style lang="scss" scoped>
.block {
  padding: 0.5rem;
  .main {
    background-color: #fff;
    padding: 0.5rem;
    border-radius: 0.3rem;
    margin-bottom: 0.5rem;
    .photo {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      margin-right: 1rem;
    }
    .sex-img {
      width: 1.25rem;
    }
    .sex {
      color: #ff3ec9;
    }
    .sex2 {
      color: #37b8d5;
    }
    .sp1 {
      display: inline-block;
      margin-top: 0.7rem;
      width: 8rem;
      color: #888;
      .total-score {
        color: #444;
        font-weight: bold;
        font-size: 1.2rem;
      }
    } 
    .btn {
      width: 4rem;
      border: 1px solid #e92162;
      padding: 0.4rem 0.4rem;
      border-radius: 0.3rem;
      color: #e92162;
      font-size: 0.85rem;
    }
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .main {
    background-color: #2c2b30;
    color: #fff;
    .sp1 {
      color: #fff;
      .total-score {
        color: #888;
      }
    }
  }
}
</style>